import defaultBookForm from "./defaultBookForm";

/* eslint-disable no-plusplus */
const areAllFieldsFalse = (obj: Record<any, any> = {}) =>
  Object.values(obj).every((field) => field?.show === false);

const getCustomForm = (
  inventoryForm: Record<any, any>,
  isUSA: boolean,
  skipGuarantorDetails: boolean,
) => {
  const initialState: Record<any, any> = {};
  const formSectionObj: Record<any, any> = {};
  const formSectionObjAfterPayment: Record<any, any> = {};
  initialState["inventoryForm"] = inventoryForm;
  initialState["isCustomFormEnabled"] = false;
  initialState["isCustomFormAfterPaymentEnabled"] = false;

  // if every fields in inventory form is false default book form will be selected
  if (
    areAllFieldsFalse(inventoryForm?.personal_form) &&
    areAllFieldsFalse(inventoryForm?.emergency_form) &&
    areAllFieldsFalse(inventoryForm?.guarantor_form) &&
    areAllFieldsFalse(inventoryForm?.additional_form)
  ) {
    initialState["isCustomFormEnabled"] = false;
    initialState["inventoryForm"] = defaultBookForm;
  } else if (inventoryForm) {
    initialState["isCustomFormEnabled"] = true;
    let idIterator = 2; // starting as 2 cause accomodation card will always be there
    if (!areAllFieldsFalse(inventoryForm?.personal_form)) {
      formSectionObj["personal_form"] = {
        show: true,
        id: idIterator.toString(),
      };
      idIterator++;
    }
    if (!areAllFieldsFalse(inventoryForm?.emergency_form)) {
      formSectionObj["emergency_form"] = {
        show: true,
        id: idIterator.toString(),
      };
      idIterator++;
    }
    if (!areAllFieldsFalse(inventoryForm?.guarantor_form) && !skipGuarantorDetails) {
      formSectionObj["guarantor_form"] = {
        show: true,
        id: idIterator.toString(),
      };
      idIterator++;
    } else {
      initialState.skipGuarantorDetails = true;
    }
    if (isUSA && !areAllFieldsFalse(inventoryForm?.additional_form)) {
      formSectionObj["additional_form"] = {
        show: true,
        id: (idIterator + 1).toString(),
      };
      idIterator += 2;
    }

    const maxIdField = Object.entries(formSectionObj).reduce(
      (max, [key, value]) => {
        if (parseInt(value.id, 10) > parseInt(max.id, 10)) {
          return { key, id: value.id };
        }
        return max;
      },
      { key: "", id: "0" },
    );

    // Add extra key to the field with max ID
    // For USA inventories, RoomMate form will have last step
    if (maxIdField.key && !isUSA) {
      formSectionObj[maxIdField.key]["isLastStep"] = true;
    }
  }

  initialState["formSectionObj"] = formSectionObj;

  // formSectionObjAfterPayment will be used for payment page
  const requiredForms = [
    "confirmation_documents",
    "emergency_form_after_payment",
    "guarantor_form_after_payment",
    "personal_form_after_payment",
    "additional_form_after_payment",
  ];

  if (Object.keys(inventoryForm).some((form: any) => requiredForms.includes(form))) {
    initialState["isCustomFormAfterPaymentEnabled"] = true;
    let idIterator = 1;
    if (!areAllFieldsFalse(inventoryForm?.personal_form_after_payment)) {
      formSectionObjAfterPayment["personal_form_after_payment"] = {
        show: true,
        id: idIterator.toString(),
      };
      idIterator++;
    }

    if (!areAllFieldsFalse(inventoryForm?.emergency_form_after_payment)) {
      formSectionObjAfterPayment["emergency_form_after_payment"] = {
        show: true,
        id: idIterator.toString(),
      };
      idIterator++;
    }

    if (!areAllFieldsFalse(inventoryForm?.guarantor_form_after_payment) && !skipGuarantorDetails) {
      formSectionObjAfterPayment["guarantor_form_after_payment"] = {
        show: true,
        id: idIterator.toString(),
      };
      idIterator++;
    }

    if (isUSA && !areAllFieldsFalse(inventoryForm?.additional_form_after_payment)) {
      formSectionObjAfterPayment["additional_form_after_payment"] = {
        show: true,
        id: idIterator.toString(),
      };
      idIterator++;
    }

    const maxIdField = Object.entries(formSectionObjAfterPayment).reduce(
      (max, [key, value]) => {
        if (parseInt(value.id, 10) > parseInt(max.id, 10)) {
          return { key, id: value.id };
        }
        return max;
      },
      { key: "", id: "0" },
    );

    if (maxIdField.key) {
      formSectionObjAfterPayment[maxIdField.key]["isLastStep"] = true;
    }

    const isDocsSectionEnabled = () =>
      Object.values(inventoryForm.confirmation_documents).some((subType: any) =>
        Object.values(subType).some((doc: any) => doc.show),
      );

    formSectionObjAfterPayment["document_section_after_payment"] = {
      show: isDocsSectionEnabled(),
    };

    initialState["formSectionObjAfterPayment"] = formSectionObjAfterPayment;
  }
  return { ...initialState };
};

export default getCustomForm;
